import { StrictRouteConfig } from "@/router/router";

export const customerRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId",
        name: "customer",
        component: () => import(/* webpackChunkName: "customer" */ "@/views/settings/customer.vue"),
        meta: {
            requiresAuth: true,
            label: "Customer details",
            title: "Customer details",
            includeInNavigation: false,
            icon: "account-tie-outline",
            matchExact: true,
            path: ["dashboard", "customers", "customer"],
            order: 20,
        },
    },
    {
        path: "/customers",
        name: "customers",
        component: () => import(/* webpackChunkName: "customer" */ "@/views/settings/customers.vue"),
        meta: {
            requiresAuth: true,
            label: "Customers",
            title: "Manage customers",
            includeInNavigation: false, // Todo: should be visible somewhere if user is superadmin
            icon: "account-tie-outline",
            matchExact: true,
            path: ["dashboard", "customers"],
        },
    },
];
